import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { CapconsegnaPage } from '../capconsegna/capconsegna';

/**
 * Generated class for the EditcapconsegnaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-editcapconsegna',
  templateUrl: 'editcapconsegna.html',
})
export class EditcapconsegnaPage {
  capConsegna;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private alertCtrl: AlertController,


  ) {

    this.capConsegna=navParams.get('cap');

  }
  alert() {
    let alert = this.alertCtrl.create({
      title: "Rimozione",
      message: "Confermi la rimozione del CAP?",
      buttons: [
        {
          text: 'Conferma',
          handler: () => this.removeCap()
        },
        {
          text: 'Annulla',
          role: 'cancel',

        }
      ]
    });
    alert.present();

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad EditcapconsegnaPage');
  }

  updateCap(){
    this.rest.aggiornaCapConsegna(this.capConsegna);
    this.navCtrl.push(CapconsegnaPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 1, 2); });

  }
  removeCap(){

    this.rest.removeCapConsegna(this.capConsegna);
    this.navCtrl.push(CapconsegnaPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 1, 2); });

  }
}



// WEBPACK FOOTER //
// ./src/pages/editcapconsegna/editcapconsegna.ts